import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InvoicesService } from '../../services/invoices.service';

export interface IInvoiceDetails {
  TOTAL: string;                    
  FEATURECODE: string;   
  INVOICEDATE: string;             
  PRICEPLAN: string;                
  INVOICENO: string;               
  QUANTITY: string;                 
  ZCUSTOMERNAME: string;           
  OUTSTANDING_BAL: string;  
  ZZPRODUCT_ID: string;                
  TAX: string;              
  INVOICEAMOUNT: string;       
  CHARGE_NAME: string;               
  SERVICE_PERIOD: string;     
  DISCOUNT: string;                 
  PROD_SUBTYPE: string | null;  
  CHARGEDATE: string;            
  AMOUNT: string;                  
  WIRECENTER: string;            
  PROD_TYPE: string;          
  ZBAN: string;                     
  DUEDATE: string;                
}

@Component({
  selector: 'app-historical-invoice-detail',
  templateUrl: './historical-invoice-detail.component.html',
  styleUrls: ['./historical-invoice-detail.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})



export class HistoricalInvoiceDetailComponent implements OnInit {

  invoiceId: any;
  invoice: any;
  invoiceItemData: IInvoiceDetails[] = [];
  invoiceDetailsReceived = false;
  totalInvoiceAmount: number = 0;

  constructor(private route: ActivatedRoute, private invoicesService: InvoicesService) {
    this.invoice = history.state.invoice;
    this.getHistoricalInvoiceDetails(this.invoice);
  }

  ngOnInit(): void { }

  getHistoricalInvoiceDetails(invoice: any) {
    this.invoiceDetailsReceived = false;
    const parts = invoice.invoice_id.split('-');

    if (parts.length === 2) {
      const bpNo = parts[0];
      const invoiceId = parts[1];

      this.invoicesService.getHistoricalInvoiceDetail(bpNo, invoiceId).subscribe((res: IInvoiceDetails[]) => {
        this.invoiceItemData = res;
        this.invoiceDetailsReceived = true;
        this.calculateTotalAmount();
      });
    } 
  }

  transformInvoiceDate(dateString: string): Date {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    return new Date(`${year}-${month}-${day}`);
  }

  calculateTotalAmount() {
    this.totalInvoiceAmount = this.invoiceItemData.reduce((total, item) => {
      return total + Number(item.AMOUNT);
    }, 0);
  }

  formatServicePeriod(servicePeriod: any) {
    // Split the service period string into start and end dates
    const [startDateStr, endDateStr] = servicePeriod.split(' to ');

    // Function to format the date from 'YYYYMMDD' to 'MM/DD/YYYY'
    const formatDate = (dateStr: string) => {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${month}/${day}/${year}`;
    };
    // Format both start and end dates
    const formattedStartDate = startDateStr && formatDate(startDateStr);
    const formattedEndDate = endDateStr && formatDate(endDateStr);

    // Return the formatted service period
    return `${formattedStartDate} to ${formattedEndDate}`;
  }

  downloadCSV() {
    let jsonData = this.invoiceItemData;
    let csvContent = "";

    function formatHeader(header: any) {
        return header.replace(/([a-z])([A-Z])/g, '$1 $2')
                     .replace(/_/g, ' ')
                     .replace(/\b\w/g, (char: any) => char.toUpperCase());
    }

    if (jsonData.length === 0) return;

    const headers = Object.keys(jsonData[0]);
    const formattedHeaders = headers.map(formatHeader);
    csvContent += formattedHeaders.join(",") + "\n";

    jsonData.forEach((item: any) => {
        const row = headers.map(header => item[header] ?? "");
        csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${this.invoice.invoice_id}-charges.csv`;;
    link.click();
  }
}








